module.exports = __webpack_public_path__ + "img/ico_notice_arrow_down.7d6e90fc.svg";